import styled from 'styled-components';

export const Page = styled.div`
  padding: 5px;
  padding-bottom: 100px;
  width: 98%;
  margin: 0px auto 0px auto;
  .ant-row {
    justify-content: center;
  }
`;

export const Imagem = styled.img`
  padding: 0px;
  margin: auto;
  height: 40vh;
`;

export const labelInputs = styled.p`
  text-align: left;
  color: var(--texto-color);
  margin: 15px 3px;
  font-size: 11pt;
`;
